import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import * as styles from './styles/styles.module.scss';
import NoResultsImage from '../../../../assets/images/icons/cuttlefish/community-content-lrg.svg';

const NoResults = ({ title, text, buttonText, handler, className }) => {
  return (
    <div className={`${styles.container} ${styles[className]}`}>
      <div>
        <img className={`${styles.image} ${styles[className]}`} src={NoResultsImage} alt="no results" />
      </div>
      <div className={`${styles.section}`}>
        <span className={styles.sub2}>{title}</span>
      </div>
      <div className={`${styles.section} ${styles.body}`}>
        <span>{text}</span>
      </div>
      <div className={`${styles.section} ${styles.callToAction}`}>
        <Button className={styles.button} onClick={handler}>
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

NoResults.defaultProps = {
  handler: () => {},
  title: '',
  text: '',
  buttonText: '',
  className: ''
};

NoResults.propTypes = {
  handler: PropTypes.func,
  title: PropTypes.string,
  text: PropTypes.string,
  buttonText: PropTypes.string,
  className: PropTypes.string
};

export default NoResults;
